import _Object$assign from 'babel-runtime/core-js/object/assign';

import { RefCounted } from '../util/disposable'; /**
                                                  * @license
                                                  * Copyright 2020 Google Inc.
                                                  * Licensed under the Apache License, Version 2.0 (the "License");
                                                  * you may not use this file except in compliance with the License.
                                                  * You may obtain a copy of the License at
                                                  *
                                                  *      http://www.apache.org/licenses/LICENSE-2.0
                                                  *
                                                  * Unless required by applicable law or agreed to in writing, software
                                                  * distributed under the License is distributed on an "AS IS" BASIS,
                                                  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                  * See the License for the specific language governing permissions and
                                                  * limitations under the License.
                                                  */

import { makeIcon } from './icon';
export class CheckboxIcon extends RefCounted {
    constructor(model, options) {
        super();
        this.element = makeIcon(_Object$assign(_Object$assign({}, options), { onClick: () => {
                model.value = !model.value;
            } }));
        this.element.classList.add('neuroglancer-checkbox-icon');
        this.element.classList.add(options.backgroundScheme === 'dark' ? 'dark-background' : 'light-background');
        const updateView = () => {
            const value = model.value;
            this.element.dataset.checked = value ? 'true' : 'false';
            this.element.title = (value ? options.disableTitle : options.enableTitle) || '';
        };
        this.registerDisposer(model.changed.add(updateView));
        updateView();
    }
}
//# sourceMappingURL=checkbox_icon.js.map